import { z } from 'zod';
export const FILE_CHUNK_BYTES = 16 * 1024;
export const MAX_FILE_BYTES = 64 * 1024 * 1024;
const path = z
    .string()
    .max(2048)
    .refine((value) => new TextEncoder().encode(value).length <= 2048 &&
    ![...value].some((char) => char.charCodeAt(0) < 32 || (char.charCodeAt(0) >= 127 && char.charCodeAt(0) <= 159)) &&
    !/[\\:*?"<>|]/u.test(value) &&
    value
        .split('/')
        .every((part) => part &&
        part !== '.' &&
        part !== '..' &&
        !/[. ]$/.test(part) &&
        !part.startsWith('.atum-transfer-') &&
        !/^(CON|PRN|AUX|NUL|COM\d|LPT\d)(\.|$)/i.test(part)));
const transfer = z.uuid();
const offset = z.number().int().min(0).max(MAX_FILE_BYTES);
export const fileRequestSchema = z.discriminatedUnion('operation', [
    z.object({ operation: z.literal('list'), path: z.union([z.literal(''), path]) }).strict(),
    z.object({ operation: z.literal('open_read'), path }).strict(),
    z.object({ operation: z.literal('read'), transfer, offset }).strict(),
    z.object({ operation: z.literal('begin_write'), path, size: offset }).strict(),
    z
        .object({
        operation: z.literal('write'),
        transfer,
        offset,
        data: z
            .string()
            .min(4)
            .max(21848)
            .regex(/^[A-Za-z0-9+/]*={0,2}$/),
    })
        .strict(),
    z
        .object({
        operation: z.literal('commit'),
        transfer,
        digest: z.string().regex(/^[a-f0-9]{64}$/),
    })
        .strict(),
    z.object({ operation: z.literal('cancel'), transfer }).strict(),
]);
export const fileRequestWrites = (request) => ['begin_write', 'write', 'commit'].includes(request.operation);
//# sourceMappingURL=files.js.map